<div class="box places">{{booking.places}}</div>
<div class="box colorPlaces slotsOccupied" [ngClass]="slotsStatus">{{ booking.slotsOccupied }}-{{ booking.routesManaged
    }}-{{ booking.routesLoadedUnloaded }}</div>

<div class="box contador" [style.color]="departureAddressSkinColor"
    [style.backgroundColor]="departureAddressSkinBackgroundColor">{{departureAddressSkin}}</div>
<div class="box contador" [style.color]="arrivalAddressSkinColor"
    [style.backgroundColor]="arrivalAddressSkinBackgroundColor">{{arrivalAddressSkin}}</div>
<div class="box carrierCode" [style.color]="carrierCodeColor" [style.backgroundColor]="carrierCodeBackgroundColor">
    {{carrierCodeSkin}}</div>
<div class="box maritimeAgency" [style.color]="maritimeAgencyColor"
    [style.backgroundColor]="maritimeAgencyBackgroundColor">{{maritimeAgencySkin}}</div>
<div class="box conflictive" [ngClass]="generalClass">
    <i class="fa fa-exclamation-triangle"></i>
</div>
<shared-booking-state class="strip" [booking]="booking" [readonly]="true"></shared-booking-state>